import { msgApi } from '../api';
import { EcoType } from '../const/enums'; // 根据会话ID，获取会话详情

export var getApps = function getApps(orgId, ecoType) {
  var _EcoType$wx$EcoType$q;

  var type = (_EcoType$wx$EcoType$q = {}, _EcoType$wx$EcoType$q[EcoType.wx] = 0, _EcoType$wx$EcoType$q[EcoType.qywx] = 0, _EcoType$wx$EcoType$q[EcoType.dingTalk] = 3, _EcoType$wx$EcoType$q[EcoType.fs] = 4, _EcoType$wx$EcoType$q)[ecoType]; // 未匹配到生态，无需鉴权

  if (Number(type) !== type) return Promise.reject('this client not suppert config');
  return msgApi.get('open/configs', {
    orgId: orgId,
    type: type
  });
};